import {useEvent} from 'Event/EventProvider'
import {useObieSteps} from 'lib/event-api/integrations/obie/steps/list'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'

export interface StepSelectProps {
  obieMilestoneId: string
  value: string | null
  onChange: (obieStepId: string | null) => void
  disabled?: boolean
}

export default function StepSelect(props: StepSelectProps) {
  const {obieMilestoneId, value, onChange, disabled} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const {data: steps = [], isLoading, error} = useObieSteps({
    client,
    event,
    obieMilestoneId,
  })

  if (isLoading) {
    return (
      <Select
        label="Step"
        aria-label="step"
        value=""
        onChange={() => {}}
        displayEmpty
        disabled
        fullWidth
      >
        <Option value="">Loading…</Option>
      </Select>
    )
  }

  if (error) {
    return (
      <Select
        label="Step"
        aria-label="step"
        helperText={error.message}
        error
        value=""
        onChange={() => {}}
        disabled
        fullWidth
      />
    )
  }

  const isSavedStepMissing =
    Boolean(value) && !steps.some((step) => step.id === value)

  return (
    <Select
      label="Step"
      aria-label="step"
      value={value ?? ''}
      onChange={(event) => onChange(String(event.target.value) || null)}
      disabled={disabled}
      displayEmpty
      fullWidth
    >
      <Option value="">Whole milestone</Option>
      {isSavedStepMissing && (
        <Option value={value} disabled>
          No longer available
        </Option>
      )}
      {steps.map((step) => (
        <Option key={step.id} value={step.id}>
          {step.name}
        </Option>
      ))}
    </Select>
  )
}
